import { EncryptionUserEntity } from '../entities/EncryptionUser';
import { authResource } from './Auth';
export const EncryptionUserResource = authResource({
    path: '/encryptions/:encryptionId/users/:groupUserId?',
    searchParams: {},
    schema: EncryptionUserEntity
}).extend((BaseResource) => ({
    add: BaseResource.getList.push.extend({
        path: '/encryptions/:encryptionId/user'
    }),
    getGenealogyList: BaseResource.getList.extend({
        path: '/encryptions/:encryptionId/users/genealogy/:genealogyId?',
        searchParams: {}
    })
}));
